module.exports = __webpack_public_path__ + "img/S1.9ef534e7.jpg";